import { HousingUnit } from '@reliance/types/models/HousingUnit';
import { IApiService, IPaginatedResponse } from '../services/api_service';

export const housingUnit = (centralApi: IApiService) => ({
  index: (params = ({} = null)): Promise<IPaginatedResponse<HousingUnit>> => {
    return centralApi.get('/housing-unit', { params });
  },
  putAudioCallEnabled: (id: number, enabled: boolean) => {
    return centralApi.put(`/housing-unit/${id}`, { audioCallingEnabled: enabled });
  },
  putVideoCallEnabled: (id: number, enabled: boolean) => {
    return centralApi.put(`/housing-unit/${id}`, { videoCallingEnabled: enabled });
  },
  putTextingEnabled: (id: number, enabled: boolean) => {
    return centralApi.put(`/housing-unit/${id}`, { textingEnabled: enabled });
  },
  putCommunicationsEnabled: (id: number, enabled: boolean) => {
    return centralApi.put(`/housing-unit/${id}`, { communicationsEnabled: enabled });
  },
});
